export const chatFontSize = `clamp(12px, 1vw, 15px)`;

export const fontSize = {
  r_XLARGE: "24px",
  r_LARGE: "20px",
  r_MIDIUM: "16px",
  r_SMALL: "14px",
  r_XSMALL: "12px",
};
